module.exports = __webpack_public_path__ + "img/package-return.540169bd.png";